export default (time) =>
	` на <span class="modal__time--green" data-rm-selected-time>${time}</span>`;
